/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} YouInputs */

const th_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณ`)
};

const en_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you`)
};

const ja_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分`)
};

const zh_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你`)
};

const es_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tú`)
};

const pt_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`você`)
};

const id_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anda`)
};

const fr_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vous`)
};

const tl_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ikaw`)
};

const vi_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bạn`)
};

const ko_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나`)
};

const de_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du`)
};

const ru_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`вы`)
};

const tr_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`siz`)
};

const it_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu`)
};

const pl_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ty`)
};

const uk_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ви`)
};

const hi_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप`)
};

const ar_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت`)
};

const ms_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anda`)
};

const bn_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি`)
};

const zh_tw2_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你`)
};

const zh_hk2_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你`)
};

const ur_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ`)
};

const fa_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شما`)
};

const sw_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wewe`)
};

const nl_you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jij`)
};

/**
* | output |
* | --- |
* | "you" |
*
* @param {YouInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const you = /** @type {((inputs?: YouInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<YouInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_you(inputs)
	if (locale === "ja") return ja_you(inputs)
	if (locale === "zh") return zh_you(inputs)
	if (locale === "es") return es_you(inputs)
	if (locale === "pt") return pt_you(inputs)
	if (locale === "id") return id_you(inputs)
	if (locale === "fr") return fr_you(inputs)
	if (locale === "tl") return tl_you(inputs)
	if (locale === "vi") return vi_you(inputs)
	if (locale === "ko") return ko_you(inputs)
	if (locale === "de") return de_you(inputs)
	if (locale === "ru") return ru_you(inputs)
	if (locale === "tr") return tr_you(inputs)
	if (locale === "it") return it_you(inputs)
	if (locale === "pl") return pl_you(inputs)
	if (locale === "uk") return uk_you(inputs)
	if (locale === "hi") return hi_you(inputs)
	if (locale === "ar") return ar_you(inputs)
	if (locale === "ms") return ms_you(inputs)
	if (locale === "bn") return bn_you(inputs)
	if (locale === "zh-TW") return zh_tw2_you(inputs)
	if (locale === "zh-HK") return zh_hk2_you(inputs)
	if (locale === "ur") return ur_you(inputs)
	if (locale === "fa") return fa_you(inputs)
	if (locale === "sw") return sw_you(inputs)
	if (locale === "nl") return nl_you(inputs)
	return en_you(inputs)
});